import { DeepClone } from "commonFunctions/commonFunctions";
import { GetRoutingData, } from "components/NavigationMenu/helper";
import NavigationMenu from "components/NavigationMenu/NavigationMenu";
import NotFound from "components/NotFound/NotFound";
import SomethingWentWrong from "components/SomethingWentWrong/SomethingWentWrong";
import TabRestrictWarning from "components/TabRestrictWarning/TabRestrictWarning";
import React, { useEffect, useState, lazy } from "react";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { MENU_OPTIONS } from "utils/constants/navigationOptions";
import { getGnrlSettings } from "../redux/generalSettings/actions/actions";
import { getGnrlSettingsActions } from "../redux/generalSettings/actions/actionCreators";
import { GetUserInfo } from "../commonFunctions/commonFunctions";
import { forceLogout } from "../commonFunctions/forceLogout";
import api from "../utils/api/api";
import * as c from "../utils/constants/constants";
import * as msg from "../utils/constants/messages";
import { connect } from 'react-redux';
import { CircularProgress } from "@mui/material";
import "../commonFunctions/tabRestrict";
const Login = lazy(() => import('../pages/Login/Login'));
const SSORedirect = lazy(() => import('../pages/SSORedirect/SSORedirect'));
const SSOLanding = lazy(() => import('../pages/SSOLanding/SSOLanding'));
const CheckIdleTime = lazy(() => import('../container/CheckIdleTime'));
const PatientCreate = lazy(() => import('../pages/PatientCreate/PatientCreate'));
const InfoScreen = lazy(() => import("../pages/InfoScreen/InfoScreen"));

const patientPopupVisiblePages = [c.PAGE_URLS[c.PAGE_DASHBOARD], c.PAGE_URLS[c.PAGE_DOC_MGMT],
c.PAGE_URLS[c.PAGE_USER_MGMT], c.PAGE_URLS[c.PAGE_MANUAL_REVIEW],
c.PAGE_URLS[c.PAGE_AUDIT_LOG], c.PAGE_URLS[c.PAGE_USER_PROFILE],
c.PAGE_URLS[c.PAGE_REPORTS], c.PAGE_URLS[c.PAGE_PATIENT]];

const getInitialTheme = () => {
  const savedTheme = localStorage.getItem("theme");
  if (savedTheme) return savedTheme;

  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  return prefersDark ? "dark" : "light";
};

const Entry = (props) => {
  const location = useLocation(null);
  const navigate = useNavigate();
  const [currentLocation, updateCurrentLocation] = useState("");
  const [routes, updateRoutes] = useState([]);
  const [publicIP, updatePublicIP] = useState('');
  const [signInSuccess, updateSignInSuccess] = useState("");
  const [loginLoading, updateLoginLoading] = useState(false);

  const [theme, setTheme] = useState("light" || getInitialTheme());

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  useEffect(() => {
    if(props.isDarkMode) setTheme("dark");
    else setTheme("light");
  }, [props.isDarkMode]);

  useEffect(() => {
    if(localStorage.getItem(c.ACCESS_TOKEN)) {
      GetRoutes();
    }
  }, [props.settings]);

  useEffect(() => {
    if(!localStorage.getItem(c.ACCESS_TOKEN)) {
      if(c.SSO === "true") {
        redirectToSSO();
      } else getIpAddress();
    }
  }, []);

  useEffect(() => {
    if(signInSuccess) {
      navigateToDashboard();
    }
  }, [signInSuccess])

  useEffect(() => {
    updateCurrentLocation(window.location?.pathname);
  }, [location]);

  const GetRoutes = () => {
    let menuOptions = MENU_OPTIONS.map(obj => DeepClone(obj));
    let routingData = GetRoutingData(menuOptions);
    updateRoutes(routingData);
  }

  const getIpAddress = () => {
    api.get_ip().then((response) => {
      updatePublicIP(response.data.ip);
    })
  }

  const getSSOAuthToken = (sso_id) => {
    localStorage.setItem(c.SSO_ID, sso_id);
    api.getAuthToken(sso_id)
    .then(res => {
      storeAuthTokens(res.data?.data[0]?.auth_token, res.data?.data[0]?.refresh_token)
    })
  }

  const redirectToSSO = () => {
    let path = window.location.href.split("?");
    if (path[1]) {
      /*checking if the present URL is coming from microsoft login - for security purpose*/
      if (document.referrer.toString().indexOf("login.microsoftonline.com") === -1) {
        setTimeout(() => {
          navigate(`/${c.PAGE_URLS[c.SSO_REDIRECT]}`);
        }, 2000);
      } else {
        let path1 = path[1].split("=");
        let path2 = path1[1];
        getSSOAuthToken(path2);
      }
    } else {
      if(c.SSO == "true") navigate(`/${c.PAGE_URLS[c.SSO_REDIRECT]}`);
      else navigate(`/${c.PAGE_URLS[c.PAGE_LOGIN]}`);
    }
  }

  const storeAuthTokens = (access, refresh) => {
    localStorage.setItem(c.ACCESS_TOKEN, access);
    localStorage.setItem(c.REFRESH_TOKEN, refresh);
    localStorage.setItem(c.USER_ROLE, GetUserInfo(access).roles[0]);
    localStorage.setItem(c.USER_ID, GetUserInfo(refresh).user_id);
    getGeneralSettings()
  }

  const handleLogin = (formData) => {
    updateLoginLoading(true);
    api.login(formData, publicIP)
    .then((response) => {
      storeAuthTokens(response.data.data[0].auth_token, response.data.data[0].refresh_token);
    })
    .catch((error) => {
      updateSignInSuccess(false);
    });
  }

  const getGeneralSettings = () => {
    api.general_settings()
      .then((response) => {
        if (response.status === 200) {
          updateLoginLoading(false);
          props.updateGeneralSettings({ ...response.data.data[0], Client_Id: response.data.data[0]?.Client_Id });
          updateSignInSuccess(true);
          setTimeout(() => {
            updateSignInSuccess('')
          }, 2000)

        }
      })
  }

  const navigateToDashboard = () => {
      setTimeout(function () {
        if(JSON.parse(localStorage.getItem("r_available")) == false) navigate(`/${c.PAGE_URLS[c.PAGE_READABL_DOWN]}`)
        else if(localStorage.getItem(c.USER_ROLE) === "Staff") navigate(`/${c.PAGE_URLS[c.PAGE_DATA]}/${c.PAGE_URLS[c.PAGE_DOC_MGMT]}`);
        else navigate(`/${c.PAGE_URLS[c.PAGE_DASHBOARD]}`);
      }, 1500);
  };

  return (

    <div className="page-main-container">
      {localStorage.getItem(c.SETTINGS) ? <CheckIdleTime /> : null}
      {patientPopupVisiblePages.find(m => currentLocation.includes(m)) ? <PatientCreate /> : null}
      <Routes>
        <Route
          path={`/${c.PAGE_URLS[c.PAGE_LOGIN]}`}
          element={c.SSO == "true" ? <SSORedirect /> : <Login handleSubmit={handleLogin} signInSuccess={signInSuccess}/>}
        />
        <Route
          path={`/${c.PAGE_URLS[c.SSO_REDIRECT]}`}
          element={<SSORedirect />}
        />
        <Route
          path={`/${c.PAGE_URLS[c.PAGE_INFO]}`}
          element={<InfoScreen navigate={navigate}/>}
        />
        {localStorage.getItem(c.ACCESS_TOKEN) ?
          <React.Fragment>
            <Route path="/" element={<Navigate to={`/${localStorage.getItem(c.USER_ROLE) === 'Staff' ? (c.PAGE_URLS[c.PAGE_DATA] + "/" + c.PAGE_URLS[c.PAGE_DOC_MGMT]) : c.PAGE_URLS[c.PAGE_DASHBOARD]}`} />} />
            {
              routes.map((m, i) => {
                const Component = m.component;
                return (<Route
                  path={m.path}
                  key={i}
                  element={<>
                    {m.hideNavigationMenu == true ? null : <NavigationMenu />}
                    <Component navigate={navigate} />
                  </>
                  }
                />)
              })
            }
          </React.Fragment>
          : <Route path="/" element={c.SSO == "true" ? <CircularProgress size={30} className="common-spinner"/> : <Navigate to={`/${c.PAGE_URLS[c.PAGE_LOGIN]}`} />} />
          }
        <Route path={`/${c.PAGE_URLS[c.PAGE_READABL_DOWN]}`} element={<SomethingWentWrong />}/>
        <Route path={`/${c.PAGE_URLS[c.PAGE_TAB_RESTRICT]}`} element={<TabRestrictWarning />}/>
        <Route path="*" element={<NotFound />}/>
      </Routes>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    settings: state.settings?.settings || {},
    isDarkMode: state.isDarkMode
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    updateGeneralSettings: url => dispatch(getGnrlSettingsActions.getGnrlSettingsActionsSuccess(url))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Entry);
